import { Placeholder } from "react-bootstrap";
import { Box } from "../styled/Elements";
import styled from "styled-components";

const SkeletonContainer = styled(Box)`
  border-radius: 10px;
  .placeholder {
    background-color: #a7a7a7;
  }
`;

const BannerSkeleton = styled.div`
  width: 100%;
  height: 260px;
  background: #e0e0e0;
  border-radius: 10px;
  margin-bottom: 20px;
`;

const ProfileInfo = styled.div`
  display: flex;
  /* align-items: center; */
  gap: 20px;
`;

const StatsContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 15px;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 15px;
`;

const ProfileSkeleton = () => {
  return (
    <SkeletonContainer>
      <BannerSkeleton />

        <ProfileInfo className="px-3">
          <Placeholder animation="wave">
            <Placeholder
              xs={3}
              className="rounded-circle"
              style={{ height: 140, width: 140 }}
            />
          </Placeholder>

          <Box className="w-100">
            <Placeholder as="h2" animation="wave">
              <Placeholder xs={12} size="lg" className="rounded"  />
            </Placeholder>
            <Placeholder as="p" animation="wave">
              <Placeholder xs={12} size="lg" className="rounded" />
            </Placeholder>
            <Placeholder as="p" animation="wave">
              <Placeholder xs={12} size="lg" className="rounded" />
            </Placeholder>
          </Box>
        </ProfileInfo>
    </SkeletonContainer>
  );
};

export default ProfileSkeleton;
